import styled from 'styled-components';

import {
  Table as SemanticTable,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Table = styled(SemanticTable)``;

export const Text = styled(TextLayoutComponent)``;

export const Square = styled.div`
  height:12px;
  width:12px;
  background: ${({ resultType }) => resultType};
  margin-right: 10px;
`;

export const SquareContainer = styled(Table.Cell)`
  display: flex;
  align-items: center;
`;

export const PathContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;
